import React, { useState, useRef, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { LanguageProvider } from "@/contexts/LanguageContext";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import CityTicker from "@/components/CityTicker";
import AboutTripex from "@/components/AboutTripex";
import About from "@/components/About";
import Dana from "@/components/Dana";
import Moments from "@/components/Testimonials";
import Onboarding from "@/components/Onboarding";
import Footer from "@/components/Footer";
import VendorRegister from "@/components/VendorRegister";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import Analytics from "@/components/Analytics";

/**
 * Scroll-reveal: attach IntersectionObserver once per mount,
 * auto-toggles `.is-in` on any element with `.reveal` when it enters viewport.
 */
function useScrollReveal() {
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          if (e.isIntersecting) {
            e.target.classList.add("is-in");
            io.unobserve(e.target);
          }
        }
      },
      { threshold: 0.12, rootMargin: "0px 0px -60px 0px" }
    );
    const observe = () => {
      document.querySelectorAll(".reveal:not(.is-in)").forEach((el) => io.observe(el));
    };
    observe();
    // Re-observe after route/lang changes (mutation)
    const mo = new MutationObserver(observe);
    mo.observe(document.body, { childList: true, subtree: true });
    return () => { io.disconnect(); mo.disconnect(); };
  }, []);
}

function Tripex() {
  useScrollReveal();
  const [presetCity] = useState("");
  const onbRef = useRef(null);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const handleStart = () => scrollTo("start");

  return (
    <div className="App relative min-h-screen overflow-x-hidden" data-testid="tripex-app" style={{ background: "#FFFFFF" }}>
      <Navbar onCtaClick={handleStart} />
      <main className="relative z-10">
        {/* Hero stays first (with the original "ما كان مكان زرناه…" tagline) */}
        <Hero onStart={handleStart} />
        <CityTicker />
        <AboutTripex />
        <About />
        <Moments />
        <div ref={onbRef}>
          <Onboarding presetCity={presetCity} />
        </div>
      </main>
      <Footer />
      {/* Dana lives ONLY as the floating bottom-right chat popover — no big section on the page */}
      <Dana />
      <FloatingWhatsApp />
    </div>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <Analytics />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Tripex />} />
          <Route path="/vendor-register" element={<VendorRegister />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}
